<mat-form-field>
  <mat-label>Laskutus alkaa</mat-label>
  <input type="text" [min]="minMonth" [matDatepicker]="picker" [formField]="kontrolli" matInput data-lpignore="true" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  @if (naytaVirhe('required')) {
    <mat-error> Laskutuksen alkamiskuukausi puuttuu. </mat-error>
  }
  @if (naytaVirhe('min') || naytaVirhe('matDatepickerMin')) {
    <mat-error> Laskutus voi alkaa aikaisintaan ensi kuussa. </mat-error>
  }
  <mat-datepicker #picker startView="year" (monthSelected)="chosenMonthHandler($event, picker)"></mat-datepicker>
</mat-form-field>
